'use client';

import { useTour } from '@reactour/tour';
import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { useDevice } from '@/modules/utils/custom-hooks/use-device';
import { Paragraph } from '@/ui-components/paragraph/paragraph';
import { ProjectContent } from '../project-content/project-content';
import { SmartCards } from '../smart-cards/smart-cards';
import { useAuth } from '@power-core/toolkit';

export const MainContent: FunctionComponent = () => {
	const t = useTranslations();
	const { project, unselectedProjectMessage } = useAppContext();
	const { auth } = useAuth();
	const { isTablet } = useDevice();
	const { isOpen } = useTour();

	return (
		<div className='relative gap-1 grid grid-cols-12 grid-rows-[auto,1fr] x-large:gap-4'>
			{!project?.documentId && !isOpen && (
				<div className='absolute w-full h-full flex items-center justify-center'>
					<div className='relative w-full z-20'>
						<Paragraph variant={isTablet ? 'h4' : 'h3'} className='text-dark text-center px-10 dark:text-white'>
							{auth?.data?.user?.email ? unselectedProjectMessage : t('T_SIGN_IN_TO_START')}
						</Paragraph>
					</div>
					<div className='absolute inset-0 bg-white opacity-10 flex items-center justify-center rounded-card z-10 dark:bg-card_dark mt-0 small:mt-12' />
				</div>
			)}
			<SmartCards />
			<ProjectContent />
		</div>
	);
};
